import React, { Component } from "react"
import { TM } from "../../common/typography/trademark"
import * as styles from "./agreementBountyContest.module.scss"

class AgreementBountyContest extends Component {
  constructor(props) {
    super(props)
    this.state = { activeCheckBox: false, enableCheckbox: false }
    this.en = this.en.bind(this)
  }

  handleCheckboxClick = e => {
    this.setState({ activeCheckBox: e.target.checked })
  }

  handleScroll = e => {
    let element = e.target
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 20) {
      this.setState({ enableCheckbox: true })
    }
  }

  render() {
    return this.en()
  }

  en() {
    return (
      <div className={styles.carouselGraphic3}>
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div className={styles.carouselText}>
              <h4>Before you enter the contest </h4>
            </div>

            <p>
              By participating in the Bounty Contest, each entrant agrees to be
              bound by the Bounty Contest Rules. Entrants further agree to be
              bound by the decisions of the Company, which shall be final and
              binding in all respects. The Company reserves the right, in its
              sole discretion, to disqualify any entrant that the Company
              believes is: (a) violating the Bounty Contest Rules; (b) tampering
              or attempting to tamper with the entry process or the operation of
              the Bounty Contest, the Bounty Contest Website, or any related
              promotional website; (c) violating the terms of service,
              conditions of use and/or general rules or guidelines of any the
              Company’s property or service; and/or (d) acting in an
              unsportsmanlike or disruptive manner, or with intent to annoy,
              abuse, threaten or harass any other person.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div
              id="rules"
              className={styles.rules}
              onScroll={this.handleScroll}
            >
              <div className={styles.heading}>
                <p>
                  IronCAP
                  <TM /> Bounty Contest
                </p>
                <p>OFFICIAL RULES</p>
              </div>
              <p>
                These rules constitute a binding agreement between each
                Participant and 01 Communique Laboratory Inc. (01 Communique).
                Please read them carefully. By agreeing to participate in this
                IronCAP
                <TM /> Bounty Contest (the “Contest”) hosted by 01 Communique,
                Participants confirm they have read and understood these rules,
                privacy policy and agree to be bound and abide by them.
              </p>
              <ol tyle="1">
                <li>
                  {" "}
                  <b>Binding Agreement</b>. You agree that submission of an
                  Entry in the Contest constitutes agreement to these Rules.
                  These Rules form a binding legal agreement between you and 01
                  Communique with respect to the Contest. 01 Communique will
                  judge the winning entry and its method of cracking, and prize
                  will be awarded in accordance with these Rules.
                </li>

                <li>
                  <b>Eligibility Criteria</b>. The Contest is open to residents
                  worldwide who meet the following criteria:
                  <ol type="a">
                    <li>
                      Entrants must be 18 years of age or older at the time of
                      entry. Age may be verified prior to awarding a Prize.
                    </li>

                    <li>
                      Entrants may not be a person residing in any country
                      subject to sanctions by Canada, or any jurisdiction where
                      the Contest is otherwise prohibited, licensed or
                      restricted. It is your responsibility to ensure that you
                      are legally eligible to enter the Contest and receive a
                      Prize under any laws applicable to you in your
                      jurisdiction of residence or otherwise.
                    </li>

                    <li>
                      Entrants who are employees, officers, directors, agents,
                      representatives and their immediate families (spouse,
                      parents, children, siblings and each of their spouses
                      regardless where they live) and any individual connected
                      with the production or distribution of this Contest are
                      not eligible to enter or be awarded a Prize.
                    </li>
                  </ol>
                </li>

                <li>
                  <b>Contest Period</b>. Registration of this Contest will be
                  opened on February 8, 2021 (EST) and will be closed on March
                  22, 2021 (EST). All dates and times are subject to change, in
                  01 Communique’s sole discretion.
                </li>

                <li>
                  <b>Entry Requirements</b>. All Entries must comply with all of
                  the following requirements (“Entry Requirements”):
                  <ol type="1">
                    <li>
                      You must have a Facebook, WeChat, or Goggle account in
                      order to register to participate in the contest. The
                      registered Individual Entrant or Team Representative who
                      submits the Entry shall be deemed the “Entrant” and/or
                      “Winner” for purposes of this Contest. Collaboration is
                      permitted within a team, but 01 Communique will not manage
                      the collaboration or prize division. The Entry is made by,
                      and is the sole responsibility of, the Entrant. 01
                      Communique will correspond with and, if applicable, award
                      the Prize to, only the Entrant. You must have all
                      necessary rights to submit your Entry to the Contest.
                    </li>

                    <li>
                      Entries that exploit bugs in 01 Communique’s software and
                      website, or otherwise violate the spirit of the Contest,
                      will be rejected.
                    </li>

                    <li>
                      Entries that attempt to harm 01 Communique or otherwise
                      create an unfair advantage over other entrants will be
                      rejected.
                    </li>

                    <li>
                      Entries cannot be in violation of any law, regulation or
                      third party rights.
                    </li>

                    <li>
                      By submitting an Entry, you warrant and represent: (a)
                      that it is your original work; (b) that it does not
                      infringe upon the copyrights, trademarks, rights of
                      privacy, publicity or other intellectual property or other
                      rights of any person or entity.
                    </li>

                    <li>
                      Entries must not include information or content that is
                      false, fraudulent, deceptive, misleading, defamatory,
                      threatening, trade libelous, slanderous, libelous,
                      disparaging, unlawfully harassing, profane, obscene,
                      pornographic, hateful, indecent, inappropriate or
                      injurious to any individual, 01 Communique, or any third
                      party.
                    </li>

                    <li>
                      You must submit the correct original pre-encrypted text
                      along with a paper in PDF format in sufficient detail
                      describing your method of cracking the text in order to
                      recreate the cracking method. 01 Communique will examine
                      your cracking method and verify if you are the prize
                      winner. All Entry materials must be in English or, if not
                      in English, the Entrant must provide an English
                      translation of the Entry as well as all other materials
                      submitted.
                    </li>

                    <li>
                      Entrant must make the Entry available free of charge and
                      without any restriction, for testing, evaluation and use
                      by 01 Communique.
                    </li>

                    <li>
                      All information provided to register for the Contest must
                      be true and correct. You are responsible for keeping such
                      information up-to-date.
                    </li>
                  </ol>
                  Only fully completed Entries are eligible, in 01 Communique’s
                  sole discretion. All interpretations of these Rules and
                  decisions made by 01 Communique relating to the Contest are
                  final and binding in all respects. At any time, in the sole
                  and absolute discretion of 01 Communique, 01 Communique shall
                  be entitled to disqualify an Individual Entrant or team in the
                  event of a failure to meet relevant eligibility criteria or
                  any other violation or suspected violation of these Rules.
                </li>

                <li>
                  <b>Winner Notification</b> &amp; <b>Prize Terms</b>. The
                  Winner, if there is one, will be notified via email on or
                  about March 26, 2021. If there is more than one entry that
                  provides the correct original text and cracking method, the
                  first one being received by 01 Communique will be the sole
                  Winner of the Prize. Only one prize will be awarded in this
                  Contest. The Winner may be required to sign an affidavit of
                  eligibility (which affirms that he/she has complied with these
                  Official Rules) as well as a liability release, each of which,
                  if issued , must be completed, signed and returned within
                  fourteen (14) days from date of issuance, or the prize will be
                  forfeited. 01 Communique is not responsible for any change of
                  email address, mailing address and/or telephone number of
                  Entrants. No transfer, assignment or substitution for prizes
                  is allowed, except at 01 Communique’s sole discretion. 01
                  Communique reserves the right to substitute a prize, in whole
                  or in part, of equal or greater monetary value if a prize
                  cannot be awarded as described for any reason.
                </li>

                <li>
                  <b>General Conditions</b>. All federal, provincial,
                  territorial and local laws and regulations apply, and the
                  Contest is void where prohibited by law. 01 Communique
                  reserves the right to disqualify any entrant from the Contest
                  if, in 01 Communique’s sole discretion, it reasonably believes
                  that the entrant has attempted to undermine the legitimate
                  operation of the Contest by cheating, deception, or other
                  unfair playing practices. 01 Communique reserves the right, in
                  its sole discretion and without prior notice, to suspend or
                  cancel any portion of the Contest or alter the Official Rules
                  for any reason, including but not limited to alteration or
                  corruption of the administration of the Contest by computer
                  virus, technical problem, electronic viruses, malicious
                  software attacks, unauthorized human intervention, systems
                  malfunctions, failures, difficulties or other causes and
                  unforeseeable events beyond the control of 01 Communique that
                  corrupt or affect the administration, security, fairness or
                  proper play or conduct of the Contest. Nothing contained
                  herein shall constitute this Contest to be an arrangement for
                  an employment, a joint venture, or a partnership.
                </li>

                <li>
                  <b>Taxes</b>. The value of the prize may be taxable to the
                  winner as income. All federal, provincial, territorial, state
                  and local taxes and any other costs and expenses associated
                  with the acceptance of prizes not specifically provided for in
                  these Rules are solely the winner’s responsibility. The Winner
                  is solely responsible for reporting and paying any and all
                  applicable taxes. Please contact your own tax advisor for any
                  questions concerning taxes.
                </li>

                <li>
                  <b>Privacy</b>. Entrants agree that personal data submitted
                  with an entry, including without limitation name, mailing
                  address, phone number, and email address may be collected,
                  processed, stored and otherwise used by 01 Communique and its
                  affiliates for the purposes of conducting and administering
                  the Contest. 01 Communique may also use your personal
                  information to send you updates and promotional materials from
                  time to time. The information collected is subject to 01
                  Communique’s privacy policy located at{" "}
                  <a href="https://www.01com.com/privacy/">
                    https://www.01com.com/privacy/
                  </a>
                  . By participating in the Contest, you agree to 01
                  Communique's privacy policy, as it may apply to the collection
                  and use of your personal information and acknowledge that you
                  have read and accepted 01 Communique’s privacy policy.
                </li>

                <li>
                  <b>Disclaimer and Limitation of Liability</b>.
                  <ol type="a">
                    <li>
                      Access to the Contest content is solely at the risk of the
                      Participant, including without limitation the risk that
                      the Contest content is inaccurate or incomplete, or that
                      the Contest Content and the transmission thereof may be
                      corrupted or contain viruses, bugs or other defects.
                    </li>

                    <li>
                      ANY ATTEMPT BY AN INDIVIDUAL TO DELIBERATELY DAMAGE ANY
                      WEBSITE ASSOCIATED WITH THIS CONTEST OR TO UNDERMINE THE
                      LEGITIMATE OPERATION OF THIS CONTEST MAY BE A VIOLATION OF
                      CRIMINAL AND/OR CIVIL LAWS. SHOULD ANY SUCH ATTEMPT BE
                      MADE, 01 COMMUNIQUE RESERVES THE RIGHT TO SEEK REMEDIES
                      AND DAMAGES TO THE FULLEST EXTENT PERMITTED BY LAW AND TO
                      BAN OR DISQUALIFY AN ENTRANT FROM THIS AND FUTURE
                      CONTESTS.
                    </li>

                    <li>
                      01 COMMUNIQUE MAKES NO WARRANTIES, CONDITIONS OR
                      REPRESENTATIONS, EXPRESS OR IMPLIED, IN FACT OR IN LAW,
                      INCLUDING ANY WARRANTY OF MERCHANTABILITY,
                      NON-INFRINGEMENT, OWNERSHIP, ACCURACY, COMPLETENESS, QUIET
                      ENJOYMENT, OR FITNESS FOR A PARTICULAR PURPOSE, AND 01
                      COMMUNIQUE DISCLAIMS ANY RESPONSIBILITY REGARDING THE
                      OPERATION OF ITS WEBSITES AND THE ACCURACY OF ANY AND ALL
                      CONTENT, OR THEIR SUITABILITY FOR THE PURPOSES OF THE
                      PARTICIPANT.
                    </li>

                    <li>
                      To the extent permitted by law, in no event shall 01
                      COMMUNIQUE and or its affiliates, suppliers of materials
                      or services, and all of their respective shareholders,
                      directors, officers, employees and agents (collectively,
                      the "Releasees") be liable for any indirect, special,
                      incidental, consequential or punitive damages, including
                      but not limited to those for business interruption or loss
                      of profits, even if the Releasees have been notified of
                      the possibility of such damage.
                    </li>

                    <li>
                      The Releasees do not assume any responsibility for, and by
                      entering, Participants release the Releasees from any and
                      all claims, actions, damages, demands and liabilities of
                      whatever nature or kind arising out of, or in connection
                      with participation or attempted participation in the
                      Contest, including, without limitation the administration
                      of the Contest, the Entry, commercialization of an Entry,
                      or the selection of a winner.
                    </li>

                    <li>
                      Without limiting the generality of the forgoing, the
                      Releasees are not responsible for:
                      <ol type="i">
                        <li>
                          the incorrect or inaccurate capture of an Entry, or
                          any component thereof;
                        </li>

                        <li>
                          late, lost, stolen, illegible, damaged, misdirected,
                          mutilated, garbled or incomplete Entries, Entries that
                          are altered or otherwise irregular, have been
                          submitted through illicit means or do not conform with
                          or satisfy any or all of the conditions of these
                          rules;
                        </li>

                        <li>
                          any loss, damage, or claims caused by the Contest
                          itself;
                        </li>

                        <li>
                          any failure of any website connected to the Contest,
                          including, without limitation, any problems, human or
                          technical, printing errors, lost, delayed, garbled
                          data or transmissions, omissions, interruptions,
                          deletions, defects or failures of any electrical
                          outlets, telephone or computer lines, technical
                          malfunctions of any computer online systems, servers,
                          access providers, computer equipment, software,
                          failure of any Entry to be received on account of
                          technical or other problems, or any combination
                          thereof including, without limitation, any injury or
                          damage to an individual’s or any other person's
                          computer related to or resulting from participating in
                          or downloading any material connected to the Contest,
                          all of which may affect a person's ability to
                          participate in the Contest;
                        </li>

                        <li>
                          any errors, omissions, incorrect or inaccurate
                          information in any Contest-related materials,
                          including, without limitation, printing or advertising
                          errors or failure of, or problems with any equipment
                          or programming associated with or used in the Contest
                          howsoever caused;
                        </li>

                        <li>
                          the security or privacy of information transmitted via
                          computer networks or for breaches of privacy due to
                          interference by third party computer "hackers" or
                          otherwise;
                        </li>

                        <li>
                          any claims regarding the accepting, arranging,
                          awarding, and declaration of the winner; and
                        </li>

                        <li>
                          any claims in any way related to the publication of an
                          Entry, including without limitation any loss of rights
                          associated therewith. Entries, Entry material/data
                          that has been tampered with or altered is void.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Participants shall not at any time assert any claim that
                      the Releasees have unlawfully or improperly used any of
                      the Participant’s ideas, and hereby release Releasees from
                      any and all liability in connection therewith.
                    </li>

                    <li>
                      01 COMMUNIQUE’s maximum liability arising from any and all
                      claims in connection with the Contest shall not exceed
                      $10.
                      <ol type="i">
                        <li>
                          Participants shall indemnify and hold 01 COMMUNIQUE
                          harmless from any claims, demands, damages,
                          liabilities and costs (including legal fees) asserted
                          by any third party relating in any way to breach of
                          the foregoing.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>

                <li>
                  <b>GENERAL</b>

                  <ol type="a">
                    <li>
                      These rules contain the entire agreement between the
                      parties with respect to the subject matter hereof and
                      supersedes all prior agreements, negotiations,
                      representations and proposals, written or oral, relating
                      to the subject matter hereof.
                    </li>

                    <li>
                      This Contest is void where prohibited by law and is
                      subject to all applicable federal, provincial and
                      municipal laws and regulations. 01 COMMUNIQUE reserves the
                      right to cancel, amend or suspend this Contest, or to
                      amend these rules, at any time, for any reason, and
                      without prior notice or obligation. Updated or amended
                      versions will be posted on ironcap.ca. Participants are
                      responsible for checking ironcap.ca regularly for any
                      updates to these rules. In the event of any discrepancy or
                      inconsistency between these rules and disclosures or other
                      statements contained in any Contest-related materials, the
                      terms and conditions of these rules posted on ironcap.ca
                      shall prevail, govern and control.
                    </li>

                    <li>
                      These rules shall be governed by and construed in
                      accordance with the laws of the Province of Ontario and
                      the federal laws of Canada applicable therein. The parties
                      hereby attorn to the exclusive jurisdiction of the
                      Superior Court of the Province of Ontario to adjudicate
                      any and all disputes regarding the validity,
                      interpretation and/or enforcement of this Agreement. The
                      parties have agreed that this agreement and all documents
                      related hereto be drafted in English. Les parties ont
                      requis que la présente convention soit redigée en anglais.
                    </li>
                  </ol>
                </li>

                <li>
                  <b>Conflict of interest rules</b>. To ensure that the Bounty
                  Contest is conducted with integrity, objectivity and
                  impartiality, all employees, directors and partners of both
                  the (1) Organiser, 01 Communique Laboratory Inc.; and (2) the
                  Exclusive Sponsor, PwC are prohibited from participating in
                  the Bounty Contest.
                </li>
              </ol>

              {/* end */}
            </div>
          </div>
        </div>

        <br />
        <div className="row">
          <div className="offset-md-2 col-md-10">
            <div className="form-check form-check-inline">
              <p>
                <input
                  checked={this.state.activeCheckBox}
                  onClick={this.handleCheckboxClick}
                  disabled={
                    this.state.enableCheckbox === false ? "disabled" : null
                  }
                  className="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox1"
                  value="option1"
                />

                <label className="form-check-label" htmlFor="inlineCheckbox1">
                  I agree{" "}
                </label>
                <br />
                <i className="text-muted">
                  (You need to read to the bottom before you can click the &lt;I
                  agree&gt; box.)
                </i>
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="offset-md-2 col-md-1">
            <button
              className="btn btn-agreement-accept"
              disabled={this.state.activeCheckBox === false ? "disabled" : null}
              onClick={this.props.handleAcceptAgreement}
            >
              Accept{" "}
            </button>
          </div>

          <div className="col-md-2">
            <button
              className="btn btn-agreement-cancel"
              onClick={this.props.handleDeclineAgreement}
            >
              Decline{" "}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default AgreementBountyContest
